import ArchiveStandingsLeague from "../ArchiveStandingsLeague.jsx";

export default function ArchiveSeason1Pro() {
    return (
        <ArchiveStandingsLeague
            sheetId="1YX4CzZlUxNIheMi_BKSoJivlo9M3g9cpcdPmqwtWroQ"
            range="archive_s1_standings_pro!A1:AI100"
            title="Archiv Season 1"
            pillClass="pill--pro"
            pillText="PRO"
            archiveText="Archivansicht der Season 1 PRO-Wertung."
        />
    );
}